import { render } from "./AdminUsersDetails.vue?vue&type=template&id=224c7e2c"
import script from "./AdminUsersDetails.vue?vue&type=script&lang=js"
export * from "./AdminUsersDetails.vue?vue&type=script&lang=js"

import "./AdminUsersDetails.vue?vue&type=style&index=0&id=224c7e2c&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__